import React from "react";
import { useI18n } from "../contexts/I18nContext";

export default function LangToggle() {
  const { lang, setLang } = useI18n();
  const next = lang === "ar" ? "en" : "ar";
  return (
    <button
      onClick={() => setLang(next)}
      data-testid="lang-toggle"
      className="btn btn-secondary btn-sm font-display"
      aria-label="Toggle language"
    >
      <span className="text-xs">{lang === "ar" ? "EN" : "ع"}</span>
    </button>
  );
}
